import { render, staticRenderFns } from "./crudInstancesCategories.vue?vue&type=template&id=68f7845a&scoped=true&"
import script from "./crudInstancesCategories.vue?vue&type=script&lang=js&"
export * from "./crudInstancesCategories.vue?vue&type=script&lang=js&"
import style0 from "./crudInstancesCategories.vue?vue&type=style&index=0&id=68f7845a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68f7845a",
  null
  
)

export default component.exports